// Utilidad para formatear/validar RUT chileno con puntos y guion de dígito verificador.
// Ejemplos: 123456789 -> 12.345.678-9 · 9876543K -> 9.876.543-K

/** Limpia el string: deja solo dígitos y K mayúscula. */
const clean = (rut) => (rut || "").toString().toUpperCase().replace(/[^0-9K]/g, "");

/** Aplica formato XX.XXX.XXX-Y mientras el usuario escribe. */
export const formatRUT = (rut) => {
  const c = clean(rut);
  if (!c) return "";
  if (c.length === 1) return c;
  const cuerpo = c.slice(0, -1);
  const dv = c.slice(-1);
  // separa el cuerpo en miles desde la derecha
  const miles = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${miles}-${dv}`;
};

/** Calcula el dígito verificador esperado para un cuerpo numérico. */
export const computeDV = (cuerpo) => {
  const num = (cuerpo || "").toString().replace(/\D/g, "");
  if (!num) return "";
  let suma = 0;
  let mult = 2;
  for (let i = num.length - 1; i >= 0; i--) {
    suma += parseInt(num[i], 10) * mult;
    mult = mult === 7 ? 2 : mult + 1;
  }
  const resto = 11 - (suma % 11);
  if (resto === 11) return "0";
  if (resto === 10) return "K";
  return String(resto);
};

/** Devuelve true si el RUT (con o sin formato) es válido. */
export const isValidRUT = (rut) => {
  const c = clean(rut);
  if (c.length < 2) return false;
  const cuerpo = c.slice(0, -1);
  const dv = c.slice(-1);
  return computeDV(cuerpo) === dv;
};

/** onChange genérico: aplica formateo y devuelve el string formateado. */
export const onChangeRUT = (e, setValue) => {
  const v = formatRUT(e.target.value);
  if (typeof setValue === "function") setValue(v);
  return v;
};
